<div *ngFor="let prompt of prompts">
    <span class="ms-4">{{prompt.label}}). </span><span [innerHTML]="prompt.questionText" class="text-start"></span>

</div>
